import styles from "./postMessage.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import Post from "../post/post";

// import { useRef } from "react"; // for images to be fixed 


const PostMessage = ({ msg, idx, variables }) => {

  const isPlayerPost = msg.speaker === "player_post";
  const profileName = msg.userName;
  
  // // if random image is needed (decided on using LurkALot for all)

  // const profilePicRef = useRef(null);

  // function getRandomProfileImage(exclude) {
  //   const { [exclude]: removed, ...remainingImages } = profileImages;
  //   const remainKeys = Object.keys(remainingImages);
  //   const randKey = remainKeys[Math.floor(Math.random()*remainKeys.length)];
  //   return remainingImages[randKey];
  // }

  // if (!isPlayerPost && !profilePicRef.current) {
  //   profilePicRef.current = getRandomProfileImage(variables.selected_profile);
  // }

  // const profilePic = isPlayerPost
  //   ? profileImages[variables.selected_profile]
  //   : profilePicRef.current;

  const profilePic = isPlayerPost
    ? ImgBuilder[`${variables.selected_profile}_small`]
    : ImgBuilder.default_img;

  return (
    <div key={idx} className={styles.postWrapper}>
      <Post message={msg.text} asset={msg.asset} isPlayerPost={isPlayerPost} profilePic={profilePic} profileName={profileName}/>
    </div>
  );
};
export default PostMessage;
